<!-- Steps aside while a sheet, menu or panel is open (Release 7, 04/11/2026, SHELL2-01). -->
@if ((entries().length || waiting()) && !overlayOpen()) {
  <div class="dl-stack" [class.dl-stack--lifted]="hasOpenDialog()"
    [class.dl-stack--over-toast]="toastLift() > 0" [style.--dl-toast-lift.px]="toastLift()">
    @if (collapsed()) {
      <button type="button" class="dl-chip" (click)="setCollapsed(false)" [title]="chipTitle()"
        [attr.aria-label]="chipTitle() + ' — show'">
        <svg lucideDownload [size]="14"></svg>
        <span class="dl-chip-count">{{ entries().length }}</span>
      </button>
    } @else {
      <button type="button" class="dl-collapse" (click)="setCollapsed(true)"
        title="Collapse — downloads keep preparing" aria-label="Collapse downloads — they keep preparing">
        <svg lucideChevronDown [size]="14"></svg>
      </button>
      @if (waiting()) {
        <div class="dl-pill dl-pill--waiting" data-testid="dl-waiting">
          <mat-spinner [diameter]="14"></mat-spinner>
          <div class="dl-pill-text">
            <span class="dl-pill-label">{{ waiting() }} more {{ waiting() === 1 ? 'playlist' : 'playlists' }} waiting</span>
            <span class="dl-pill-status">Two at a time — keep SCIOS open until they start</span>
          </div>
        </div>
      }
      @for (s of entries(); track s.requestId) {
        <div class="dl-pill" [class.dl-pill--ready]="s.phase === 'ready'"
          [class.dl-pill--failed]="s.phase === 'failed'">
          @if (s.phase === 'preparing' || s.phase === 'queued') {
            <mat-spinner [diameter]="14"></mat-spinner>
          } @else {
            <svg lucideDownload [size]="14"></svg>
          }
          <div class="dl-pill-text">
            <span class="dl-pill-label">{{ s.label }}</span>
            <span class="dl-pill-status">{{ statusLine(s) }}</span>
            @if (subLine(s)) {
              <span class="dl-pill-sub">{{ subLine(s) }}</span>
            }
          </div>
          @if (s.phase === 'ready') {
            <button type="button" class="dl-pill-action" (click)="onSave(s)"
              [attr.aria-label]="(s.saved ? 'Save again: ' : 'Save: ') + s.label">
              {{ s.saved ? 'Save again' : 'Save' }}
            </button>
          }
          @if (canDismiss(s)) {
            <button type="button" class="dl-pill-close" (click)="onDismiss(s)" title="Clear"
              [attr.aria-label]="'Clear ' + s.label + ' from this list'">
              <svg lucideX [size]="12"></svg>
            </button>
          }
        </div>
      }
    }
  </div>
}
